import React, { useState, useEffect } from 'react';
import { Share2, Settings, Search } from 'lucide-react';

const TEXT_TITLE = '#1a1a2e';
const TEXT_MUTED = '#64748b';
const TEXT_FAINT = '#94a3b8';
const BORDER = '#e2e8f0';
const SURFACE = '#ffffff';

function SheetToolbar({ sheet, role, onRenameSheet, onOpenShare, onOpenSettings, searchQuery, onSearchChange }) {
  const [editingName, setEditingName] = useState(false);
  const [draftName, setDraftName] = useState(sheet.name || '');

  useEffect(() => { setDraftName(sheet.name || ''); }, [sheet.name]);

  const canEdit = role === 'owner' || role === 'editor';

  const commitName = async () => {
    setEditingName(false);
    if (draftName.trim() && draftName !== sheet.name) {
      try { await onRenameSheet(draftName.trim()); } catch (_e) { setDraftName(sheet.name); }
    } else {
      setDraftName(sheet.name);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 24px', borderBottom: `1px solid ${BORDER}`, background: SURFACE, flexWrap: 'wrap' }}>
      <div style={{ flex: '1 1 200px', minWidth: 0 }}>
        {editingName ? (
          <input
            autoFocus
            value={draftName}
            onChange={(e) => setDraftName(e.target.value)}
            onBlur={commitName}
            onKeyDown={(e) => { if (e.key === 'Enter') commitName(); if (e.key === 'Escape') { setEditingName(false); setDraftName(sheet.name); } }}
            style={{ fontSize: '1.5rem', fontWeight: 600, fontStyle: 'italic', color: TEXT_TITLE, border: `1px solid ${BORDER}`, borderRadius: '6px', padding: '4px 8px', width: '100%', maxWidth: '480px', background: SURFACE }}
          />
        ) : (
          <h1
            onClick={() => canEdit && setEditingName(true)}
            style={{ margin: 0, fontSize: '1.5rem', fontWeight: 600, fontStyle: 'italic', color: TEXT_TITLE, cursor: canEdit ? 'text' : 'default', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            title={canEdit ? 'Click to rename' : undefined}
          >
            {sheet.name}
          </h1>
        )}
      </div>

      <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '6px 10px', background: SURFACE, border: `1px solid ${BORDER}`, borderRadius: '999px', maxWidth: '280px', flex: '0 1 240px' }}>
        <Search size={14} color={TEXT_FAINT} />
        <input
          type="search"
          placeholder="Search cards…"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ flex: 1, border: 'none', outline: 'none', background: 'transparent', fontSize: '0.9rem', color: TEXT_MUTED }}
        />
      </div>

      <button
        type="button"
        onClick={onOpenShare}
        style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '8px 14px', background: SURFACE, color: TEXT_MUTED, border: `1px solid ${BORDER}`, borderRadius: '999px', fontSize: '0.85rem', fontWeight: 500, cursor: 'pointer' }}
      >
        <Share2 size={14} /> Share
      </button>
      <button
        type="button"
        onClick={onOpenSettings}
        style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '8px 14px', background: SURFACE, color: TEXT_MUTED, border: `1px solid ${BORDER}`, borderRadius: '999px', fontSize: '0.85rem', fontWeight: 500, cursor: 'pointer' }}
      >
        <Settings size={14} /> Settings
      </button>
    </div>
  );
}

export default SheetToolbar;
